<template>
  <div class="mb-5">
    <div class="fv-row">
      <!--begin::Label-->
      <label class="form-label">{{ label }}</label>
      <!--end::Label-->
      <!--begin::Input-->
      <textarea
        class="form-control"
        data-kt-autosize="true"
        rows="3"
        :value="modelValue"
        @input="updateValue"
      ></textarea>
      <!--end::Input-->
      <!--begin::Description-->
      <div class="text-muted fs-7"></div>
      <!--end::Description-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    label: String,
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>
